// import { getCurrentEmailsFromLocalStorage, setCurrentEmailsInLocalStorage } from "helpers/sf_utils"
import { buildCampaignAnalysisCacheKey } from "helpers/sf_utils"
import {
  GET_CALLS,
  GET_CALLS_SUCCESS,
  GET_CALLS_ERROR,
  GET_CALL_TRANSCRIPTION,
  GET_CALL_TRANSCRIPTION_SUCCESS,
  GET_CALL_TRANSCRIPTION_ERROR,
  GET_CALL_TRANSCRIPTION_SETTINGS,
  GET_CALL_TRANSCRIPTION_SETTINGS_SUCCESS,
  GET_CALL_TRANSCRIPTION_SETTINGS_ERROR,
  UPDATE_CALL_TRANSCRIPTION_SETTINGS,
  UPDATE_CALL_TRANSCRIPTION_SETTINGS_SUCCESS,
  UPDATE_CALL_TRANSCRIPTION_SETTINGS_ERROR,
  GET_CALL_TRANSCRIPTION_TOPICS,
  GET_CALL_TRANSCRIPTION_TOPICS_SUCCESS,
  GET_CALL_TRANSCRIPTION_TOPICS_ERROR,
  CREATE_CALL_TRANSCRIPTION_TOPIC,
  CREATE_CALL_TRANSCRIPTION_TOPIC_SUCCESS,
  CREATE_CALL_TRANSCRIPTION_TOPIC_ERROR,
  UPDATE_CALL_TRANSCRIPTION_TOPIC,
  UPDATE_CALL_TRANSCRIPTION_TOPIC_SUCCESS,
  UPDATE_CALL_TRANSCRIPTION_TOPIC_ERROR,
  DELETE_CALL_TRANSCRIPTION_TOPIC,
  DELETE_CALL_TRANSCRIPTION_TOPIC_SUCCESS,
  DELETE_CALL_TRANSCRIPTION_TOPIC_ERROR,
  UPDATE_CALL,
  UPDATE_CALL_SUCCESS,
  UPDATE_CALL_ERROR
} from "./actionTypes"

const INIT_STATE = {
  calls: [],
  call_transcriptions: [],
  call_transcriptions_loading: false,
  call_transcriptions_error: null,
  error: null,
  loading: false,
  last_page_fetched: 0,
  last_fetched_at: null,
  total_number_of_pages: 0,
  last_start_date: null,
  last_end_date: null,
  has_next_page: false,
  has_lookahead_pages: false,
  page_size: null,
  active_cache_key: null,
  page_cache: {},
  call_transcription_settings: null,
  call_transcription_settings_loading: false,
  call_transcription_settings_error: null,
  call_transcription_topics: null,
  call_transcription_topics_loading: false,
  call_transcription_topics_error: null,
}
const Calls = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CALLS: {
      const queryParams = action.payload?.queryParams || {}
      const { start_date, end_date, page_number } = queryParams
      const shouldReplaceResults = Boolean(action.payload?.replaceResults)
      const useCache = Boolean(action.payload?.useCache)
      const cacheKey = useCache ? buildCampaignAnalysisCacheKey(queryParams) : null
      const cachedPage = useCache ? state.page_cache?.[cacheKey]?.[page_number] : null
      let date_range_changed = false
      if (!(start_date == state.last_start_date && end_date == state.last_end_date)) {
        date_range_changed = true
      }
      const shouldResetRows = shouldReplaceResults || page_number === 1 || page_number !== (state.last_page_fetched + 1)
      return {
        ...state,
        error: null,
        loading: !cachedPage,
        calls: cachedPage?.rows || (shouldResetRows ? [] : state.calls),
        last_page_fetched: cachedPage?.page_number || (date_range_changed ? 0 : state.last_page_fetched),
        total_number_of_pages: cachedPage?.total_number_of_pages || state.total_number_of_pages,
        has_next_page: typeof cachedPage?.has_next_page === 'boolean' ? cachedPage.has_next_page : state.has_next_page,
        has_lookahead_pages: typeof cachedPage?.has_lookahead_pages === 'boolean' ? cachedPage.has_lookahead_pages : state.has_lookahead_pages,
        page_size: cachedPage?.page_size || state.page_size,
        active_cache_key: useCache ? cacheKey : null,
      }
    }

    case GET_CALLS_SUCCESS: {
      const payloadData = action.payload.data
      const rows = Array.isArray(payloadData) ? payloadData : []
      const additional = action.payload.additional_data || {}
      const useCacheMeta = Boolean(action.meta?.useCache)
      const metaQueryParams = action.meta?.queryParams || {}
      const cacheKey = useCacheMeta ? buildCampaignAnalysisCacheKey(metaQueryParams) : null
      const shouldReplaceResults = Boolean(action.meta?.replaceResults)
      const pageNum = parseInt(additional.page_number, 10)
      const totalPages = parseInt(additional.total_number_of_pages, 10)
      const safePage = Number.isFinite(pageNum) && pageNum > 0 ? pageNum : 1
      const safeTotal = Number.isFinite(totalPages) && totalPages >= 0 ? totalPages : 0
      const hasNextPage = typeof additional.has_next_page === 'boolean' ? additional.has_next_page : false
      const hasLookAheadPages = typeof additional.has_lookahead_pages === 'boolean' ? additional.has_lookahead_pages : false
      const pageSize = Number(additional.page_size) || null
      const pageSnapshot = {
        rows,
        page_number: safePage,
        total_number_of_pages: safeTotal,
        has_next_page: hasNextPage,
        has_lookahead_pages: hasLookAheadPages,
        page_size: pageSize,
      }
      let uniqueCalls = []
      if (shouldReplaceResults) {
        uniqueCalls = rows
      } else {
        const all_calls = [...state.calls, ...rows]
        all_calls.forEach(function (item) {
          const i = uniqueCalls.findIndex(x => x.id === item.id);
          if (i <= -1) {
            uniqueCalls.push(item);
          }
        });
      }

      return {
        ...state,
        error: null,
        calls: uniqueCalls,
        loading: false,
        last_fetched_at: new Date(),
        last_page_fetched: safePage,
        last_start_date: additional.start_date,
        last_end_date: additional.end_date,
        total_number_of_pages: safeTotal,
        has_next_page: hasNextPage,
        has_lookahead_pages: hasLookAheadPages,
        page_size: pageSize,
        active_cache_key: useCacheMeta ? cacheKey : state.active_cache_key,
        page_cache: useCacheMeta ? {
          ...state.page_cache,
          [cacheKey]: {
            ...(state.page_cache?.[cacheKey] || {}),
            [safePage]: pageSnapshot,
          },
        } : state.page_cache,
      }
    }

    case GET_CALLS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        has_next_page: false,
        has_lookahead_pages: false,

      }

    case UPDATE_CALL:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case UPDATE_CALL_SUCCESS:
      return {
        ...state,
        error: null,
        calls: state.calls.map(call => call.id === action.payload.id ? action.payload : call),
        loading: false,
      }
      
    case UPDATE_CALL_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_CALL_TRANSCRIPTION:
      return {
        ...state,
        call_transcriptions_error: null,
        call_transcriptions_loading: true,
        call_transcriptions: []
      }

    case GET_CALL_TRANSCRIPTION_SUCCESS:
      return {
        ...state,
        call_transcriptions_error: null,
        call_transcriptions_loading: false,
        call_transcriptions: action.payload
      }

    case GET_CALL_TRANSCRIPTION_ERROR:
      return {
        ...state,
        call_transcriptions_error: action.payload,
        call_transcriptions_loading: false,
        call_transcriptions: []
      }

    case GET_CALL_TRANSCRIPTION_SETTINGS:
      return {
        ...state,
        call_transcription_settings_error: null,
        call_transcription_settings_loading: true
      }

    case GET_CALL_TRANSCRIPTION_SETTINGS_SUCCESS:
      return {
        ...state,
        call_transcription_settings_error: null,
        call_transcription_settings_loading: false,
        call_transcription_settings: action.payload.data
      }

    case GET_CALL_TRANSCRIPTION_SETTINGS_ERROR:
      return {
        ...state,
        call_transcription_settings_error: action.payload,
        call_transcription_settings_loading: false
      }

    case UPDATE_CALL_TRANSCRIPTION_SETTINGS:
      return {
        ...state,
        call_transcription_settings_error: null,
        call_transcription_settings_loading: true
      }

    case UPDATE_CALL_TRANSCRIPTION_SETTINGS_SUCCESS:
      return {
        ...state,
        call_transcription_settings_error: null,
        call_transcription_settings_loading: false,
        call_transcription_settings: action.payload
      }

    case UPDATE_CALL_TRANSCRIPTION_SETTINGS_ERROR:
      return {
        ...state,
        call_transcription_settings_error: action.payload,
        call_transcription_settings_loading: false
      }

    case GET_CALL_TRANSCRIPTION_TOPICS:
      return {
        ...state,
        call_transcription_topics_error: null,
        call_transcription_topics_loading: true
      }

    case GET_CALL_TRANSCRIPTION_TOPICS_SUCCESS:
      let topics = action.payload.data
      topics = topics.sort((a, b) => a.id - b.id)
      return {
        ...state,
        call_transcription_topics_error: null,
        call_transcription_topics_loading: false,
        call_transcription_topics: topics
      }

    case GET_CALL_TRANSCRIPTION_TOPICS_ERROR:
      return {
        ...state,
        call_transcription_topics_error: action.payload,
        call_transcription_topics_loading: false
      }

    case CREATE_CALL_TRANSCRIPTION_TOPIC:
      return {
        ...state,
        call_transcription_topics_error: null,
        call_transcription_topics_loading: true
      }

    case CREATE_CALL_TRANSCRIPTION_TOPIC_SUCCESS:
      let topics_result = [...state.call_transcription_topics, action.payload]
      topics_result = topics_result.sort((a, b) => a.id - b.id)
      return {
        ...state,
        call_transcription_topics_error: null,
        call_transcription_topics_loading: false,
        call_transcription_topics: topics_result
      }

    case CREATE_CALL_TRANSCRIPTION_TOPIC_ERROR:
      return {
        ...state,
        call_transcription_topics_error: action.payload,
        call_transcription_topics_loading: false
      }

    case UPDATE_CALL_TRANSCRIPTION_TOPIC:
      return {
        ...state,
        call_transcription_topics_error: null,
        call_transcription_topics_loading: true
      }

    case UPDATE_CALL_TRANSCRIPTION_TOPIC_SUCCESS:
      {
        const topic_id = action.payload.id;
        const unchanged_topics = state.call_transcription_topics.filter(topic => topic.id !== topic_id)
        let updated_topics = [...unchanged_topics, action.payload]
        updated_topics = updated_topics.sort((a, b) => a.id - b.id)
        return {
          ...state,
          call_transcription_topics_error: null,
          call_transcription_topics_loading: false,
          call_transcription_topics: updated_topics
        }
      }

    case UPDATE_CALL_TRANSCRIPTION_TOPIC_ERROR:
      return {
        ...state,
        call_transcription_topics_error: action.payload,
        call_transcription_topics_loading: false
      }

    case DELETE_CALL_TRANSCRIPTION_TOPIC:
      return {
        ...state,
        call_transcription_topics_error: null,
        call_transcription_topics_loading: true
      }

    case DELETE_CALL_TRANSCRIPTION_TOPIC_SUCCESS:
      return {
        ...state,
        call_transcription_topics_error: null,
        call_transcription_topics_loading: false,
        call_transcription_topics: state.call_transcription_topics.filter(element => element.id !== action.payload.id)
      }

    case DELETE_CALL_TRANSCRIPTION_TOPIC_ERROR:
      return {
        ...state,
        call_transcription_topics_error: action.payload,
        call_transcription_topics_loading: false
      }

    default:
      return state
  }
}

export default Calls
